module.exports = __webpack_public_path__ + "img/loginLogo.99583fd1.jpg";